const ENDPOINT = "https://tubegether.onrender.com/"

export default ENDPOINT
